export default __webpack_public_path__ + "static/DrawOnAnything-5f0de883a64d603122408813a549cea1.webp";